// Precisa ser o primeiro import do arquivo: registra os listeners de
// recuperação (ver src/kioskWatchdog.js) antes de qualquer outro módulo
// rodar, pra pegar até erro que aconteça durante a inicialização deles.
import "./kioskWatchdog";
// Segundo: captura global de erros (ver src/service/monitoramentoErros.js).
import "./capturaGlobalErros";
import {
  configurarMonitoramento,
  reportarErro,
} from "@/service/monitoramentoErros";
import { COLLECTION_ERROS } from "@/service/collectionsNames";
import BtnVoltar from "@/components/btnVoltar";
import vTimeout from "@/components/vTimeount";
import labelEtapa from "@/constants/etapaCompra";
import timePage from "@/constants/timeout_page";
import {
  aguardarLogin,
  db,
  removeCodeFirebase,
  setCompra,
  setEtapaCompraLocal,
} from "@/service/firebase";
import {
  deveAdiarManutencao,
  deveAguardarResultadoPagamento,
  iniciarEscutaCompraAtual,
  sincronizarAprovacaoCompraLocal,
} from "@/service/purchaseSession";
import { recordScreenVisit } from "@/service/screenVisits";
import { iniciarEnvioUsoMolduras } from "@/service/molduraUsageTelemetry";
import { manutencaoEfetiva } from "@/service/totemOperation";
import { iniciarKeepAliveTotem } from "@/service/keepAliveTotem";
import { finalizarCompraSemCobranca } from "@/service/vendaEvento";
import { pulaEtapaPagamento } from "@/utils/cobrancaTotem";
import axios from "axios";
import {
  Timestamp,
  // MANUTENCAO
  addDoc,
  collection,
  doc,
  onSnapshot,
} from "firebase/firestore";
import Vue from "vue";
import App from "./App.vue";
import "./index.css";
import vuetify from "./plugins/vuetify";
import "./registerServiceWorker";
import router from "./router";
import "./scss/index.scss";
import store from "./store";

// Destino e contexto dos erros. Em development fica só no console, como antes
// (o e2e com emulador liga com VUE_APP_MONITORAMENTO_ERROS=true).
configurarMonitoramento({
  ativo:
    process.env.VUE_APP_ENV !== "development" ||
    process.env.VUE_APP_MONITORAMENTO_ERROS === "true",
  // As regras só aceitam gravação do totem logado: erro do boot espera o
  // login do /init (até 60 s) em vez de ser recusado.
  gravarFirestore: (payload) =>
    aguardarLogin().then(() =>
      addDoc(collection(db, COLLECTION_ERROS), payload)
    ),
  contexto: () => ({
    totemId:
      store.getters["totem/getTotem"]?.id || router.currentRoute?.params?.id,
    compraId: store.getters["compra/getCompra"]?.id,
    rota: router.currentRoute?.path,
  }),
});

iniciarEnvioUsoMolduras(() => store.getters["totem/getTotem"]?.id);

router.afterEach((to) => {
  const compraId = store.getters["compra/getCompra"]?.id;
  // Registrar apenas navegação concluída, sem bloquear a jornada se a rede
  // falhar. Este ponto de montagem evita o ciclo router → firebase → router.
  recordScreenVisit(db, to.path, compraId).catch((error) => {
    console.warn("Falha ao registrar visita de tela:", error);
  });
});

Vue.component("btn-voltar", BtnVoltar);
Vue.component("vBtnReset", () => import("@/components/vBtnReset"));
Vue.component("vLogoDefault", () => import("@/components/vLogoDefault"));
/*
import { makeServer } from "./mirage";
if (process.env.VUE_APP_ENV === "development") {
  makeServer({ environment: "development" });
}
*/

axios.defaults.baseURL = "http://localhost:9000";
axios.defaults.headers.post["Content-Type"] = "application/json;charset=utf-8";
axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    return Promise.reject(error.response);
  }
);

Vue.component("vTimeout", vTimeout);
Vue.config.productionTip = false;

// Erro de render, watcher, hook ou handler de componente. Com handler próprio o
// Vue não loga mais sozinho, então o console.error aqui é o log local. O envio
// é assíncrono e nunca lança: a tela segue como o Vue deixou.
Vue.config.errorHandler = (err, vm, info) => {
  let componente = null;
  try {
    componente = vm && vm.$options && vm.$options.name;
  } catch (_) {
    componente = null;
  }
  const detalhe = componente ? `${info} (${componente})` : info;
  reportarErro(err, { origem: "vue", info: detalhe });
  console.error("[vue]", detalhe, err);
};

// Aviso do Vue só existe no build de desenvolvimento (o de produção remove os
// avisos). Antes ia para a coleção `erros` como se fosse erro; agora só console.
Vue.config.warnHandler = (msg, vm, trace) => {
  console.warn(`[Vue warn]: ${msg}${trace || ""}`);
};

// Sentry.init({
//   Vue,  // Passa a instância Vue para o Sentry
//   dsn: "https://5d01bfbdbf2149e530f33715dfd8beb9@o4507420778299392.ingest.us.sentry.io/4507420782952448",
//   integrations: [
//     Sentry.browserTracingIntegration(),  // Integração de rastreamento do navegador para monitoramento de desempenho
//     Sentry.replayIntegration(),  // Integração para reprodução de sessões
//   ],
//   // Performance Monitoring
//   tracesSampleRate: 1.0, // Captura 100% das transações
//   // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//   tracePropagationTargets: ["localhost", /^https:\/\/app\.photonow\.com\.br/],
//   // Session Replay
//   replaysSessionSampleRate: 0.1, // Define a taxa de amostragem de sessões em 10%. Pode ser alterada para 100% durante o desenvolvimento e uma taxa menor em produção.
//   replaysOnErrorSampleRate: 1.0, // Se você não estiver amostrando toda a sessão, altera a taxa de amostragem para 100% quando ocorrerem erros nas sessões.
// });

const appvue = new Vue({
  data() {
    return {
      handlerTotemFirebase: function () {},
    };
  },
  methods: {
    getAFK() {
      return this.$store.getters["totem/getAFK"];
    },
    chapters() {
      return labelEtapa;
    },
    async SairDaCompra(status) {
      if (status === labelEtapa[status]) {
        let compra = store.getters["compra/getCompra"];
        compra.etapa = labelEtapa[status];
        await removeCodeFirebase();
        await setCompra(compra);
      } else {
        console.error("Erro de REFERENCIA, contactar o suporte");
        this.infoModal("Erro de REFERENCIA, contactar o suporte");
      }
    },
    // Mantido pelo nome porque as telas chamam `this.$root.sendOneError`.
    // Fire-and-forget: volta na hora, nunca lança, nunca espera a rede.
    // (Antes gravava o objeto Error cru no Firestore, que o addDoc recusa —
    // a maior parte dos erros com Error nunca chegava na coleção.)
    sendOneError(err, tracker) {
      reportarErro(err, { origem: "tela", info: tracker });
    },
    // Chamado pela tela /error-config: registra as falhas de configuração que
    // levaram o totem até ela.
    sendError(mensagem) {
      let erros = [];
      try {
        erros = this.$store.getters["totem/getErros"] || [];
      } catch (_) {
        erros = [];
      }
      const mensagens = erros.map((e) => e && e.mensagem).filter(Boolean);
      if (mensagem) mensagens.push(mensagem);
      if (!mensagens.length) return;
      reportarErro(mensagens.join(" | "), {
        origem: "error-config",
        nivel: "aviso",
      });
    },
    goto(rota) {
      if (this.$route.path == rota) {
        return;
      } else {
        this.$router.push(rota);
      }
    },
    errorConfig(mensagem, redir) {
      this.$store.commit("totem/setError", {
        mensagem: mensagem,
      });
      if (redir) {
        this.$router.push("/error-config");
      }
    },
    redirectsPorData(compraEtapa) {
      // O bypass pode gravar a compra antes de navegar. Aplicar a manutenção
      // antes desse efeito financeiro e conservar uma cobrança já em curso,
      // mesmo quando a configuração de pagamento muda enquanto aguarda.
      if (manutencaoEfetiva(this.$store.getters["totem/getTotem"])) {
        if (!deveAdiarManutencao(this.$store, this.$route.path)) {
          this.goto("/manutencao");
          return;
        }
        if (
          compraEtapa === labelEtapa.PAGAMENTO_PROCESSO &&
          deveAguardarResultadoPagamento(this.$store, this.$route.path)
        ) {
          this.goto("/cabine/pagamento-em-processo");
          return;
        }
      }
      //console.log("====> compraEtapa alterada", compraEtapa);
      switch (compraEtapa) {
        case labelEtapa.CANCELADA:
          this.goto("/cabine/home");
          break;
        case labelEtapa.EXPIROU:
          this.goto("/cabine/home");
          break;
        case labelEtapa.TIPO_FOTO:
          this.goto("/cabine/selecione-tipo-foto");
          break;
        case labelEtapa.MODO_CAPTURA:
          this.goto("/cabine/selecione-modo-captura");
          break;
        case labelEtapa.QTDE_FOTO:
          this.goto("/cabine/selecione-qtd-foto");
          break;
        case labelEtapa.SCAN_QR_CODE:
          this.goto("/cabine/scan-qr-code");
          break;
        case labelEtapa.SELFIE:
          this.goto("/cabine/selfie");
          break;
        case labelEtapa.UPLOAD:
          this.goto("/cabine/aguardando-upload");
          break;
        case labelEtapa.EDICAO:
          this.goto("/cabine/editor");
          break;
        case labelEtapa.PAGAMENTO_SELECT:
          if (pulaEtapaPagamento(this.$store.getters["totem/getTotem"])) {
            finalizarCompraSemCobranca();
          } else {
            this.goto("/cabine/seleciona-pagamento");
          }
          break;
        case labelEtapa.PAGAMENTO_PROCESSO:
          if (pulaEtapaPagamento(this.$store.getters["totem/getTotem"])) {
            finalizarCompraSemCobranca();
          } else {
            this.goto("/cabine/pagamento-em-processo");
          }
          break;
        case labelEtapa.PAGAMENTO_SUCESSO:
          this.goto("/cabine/pagamento-sucesso");
          break;
        case labelEtapa.PAGAMENTO_FALHOU:
          if (pulaEtapaPagamento(this.$store.getters["totem/getTotem"])) {
            finalizarCompraSemCobranca();
          } else {
            this.goto("/cabine/pagamento-falha");
          }
          break;
        case labelEtapa.IMPRESSAO:
          this.goto("/cabine/impressao");
          break;
        case labelEtapa.AGRADECIMENTO:
          break;
        default:
          this.goto("/404");
      }
    },
    CreatListenerPurchase() {
      let compra = this.$store.getters["compra/getCompra"];
      if (!compra || !compra.id) return;

      let docRef = doc(db, "compras", compra.id);
      iniciarEscutaCompraAtual({
        criarEscuta: (aoAtualizar) => onSnapshot(docRef, aoAtualizar),
        aoAtualizar: (snapshot) => {
          if (snapshot.exists()) {
            let compraPayload = snapshot.data();
            sincronizarAprovacaoCompraLocal(
              this.$store,
              compraPayload,
              compra.id
            );
            setEtapaCompraLocal(compraPayload.etapa);
            this.redirectsPorData(compraPayload.etapa);
          }
        },
      });
    },
    getTimeoutName(name) {
      return timePage[name];
    },
    mockmode(mode_etapa) {
      let estapa_mock;
      if (mode_etapa && labelEtapa[mode_etapa]) {
        estapa_mock = mode_etapa;
      } else {
        this.infoModal("Falha ao tentar mockar a etapa não existe");
        return false;
      }
      const compraMock = {
        codigo_gateway_pag: null,
        data_hora: Timestamp.fromDate(new Date()),
        etapa: estapa_mock,
        id: "mockTestDev2026",
        keep_alive: Timestamp.fromDate(new Date()),
        qtde_foto: 2,
        tipo_foto: "polaroid",
        valor: 50,
        flags: ["mock"],
        pago: false,
        totem_id: "481CoxABjBv3kVoFEmwo", // totem trulogic para testes
        tipoCartao: "PIX",
        code: null,
        mocke: true,
        cupom: null,
      };
      this.$store.commit("compra/setCompra", compraMock);
      setCompra(compraMock);

      setTimeout(() => {
        this.CreatListenerPurchase();
      }, 1000);
    },
    infoModal(mensagem) {
      this.$store.commit("setModal", {
        tipo: "info",
        mensagem: mensagem,
        toggle: true,
      });
    },
  },
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");

iniciarKeepAliveTotem();

// ── Hook de teste (nunca em produção) ────────────────────────────────────────
// Os testes E2E precisam abrir uma tela do meio do fluxo (editor, pagamento,
// impressão) sem criar uma compra de verdade no Firebase — o que dependeria de
// rede e sujaria o projeto. Com o store e o router acessíveis, o Cypress semeia
// o estado e navega direto, mantendo o teste determinístico e offline.
if (process.env.VUE_APP_ENV !== "production") {
  window.__PHOTONOW_TEST__ = { app: appvue, store, router };
}
